export const h1 = 32;
export const subHeading = 12;

export const small = 6;
export const medium = 12;
export const large = 26;
export const extraLarge = 44;
export const huge = 56;

export const pagePadding = 18;

export const margin = 35;

export const gap = 10;
export const deviceMargin = { mobile: 16, tablet: 32, largeScreen: 138 };

export const tabletDevice = 481;
export const desktopDevice = 769;
export const largeScreens = 1280;
